const Home = () => {
    return (
        <div className="w-full h-screen">...</div>
    );
};

export default Home;
